import EditAccount from './container';

export default EditAccount;
